/**
 * RequireRole — role-based access guard.
 * Wraps routes/sections that should only render for specific roles.
 * Redirects to /unauthorized when the current role is not in the allow list.
 */

import { type ReactNode } from 'react'
import { Navigate }       from 'react-router'
import { useRole }        from '@/hooks/useAuth'
import { PATHS }          from '@/router/paths'
import type { Role }      from '@/types/roles'

interface Props {
  allowedRoles: readonly Role[]
  children:     ReactNode
}

export function RequireRole({ allowedRoles, children }: Props): ReactNode {
  const role = useRole()
  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to={PATHS.unauthorized} replace />
  }
  return <>{children}</>
}
